"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_TO_SPEECH_OPTIONS = exports.AVAILABLE_LANGUAGES = void 0;
const AVAILABLE_LANGUAGES = exports.AVAILABLE_LANGUAGES = {
  ENGLISH: 'ENGLISH',
  SPANISH: 'SPANISH',
  PORTUGUESE: 'PORTUGUESE',
  FRENCH: 'FRENCH',
  ARMENIAN: 'ARMENIAN',
  RUSSIAN: 'RUSSIAN',
  TAGALOG: 'TAGALOG',
  GERMAN: 'GERMAN',
  UKRAINIAN: 'UKRAINIAN',
  ARABIC: 'ARABIC',
  CANTONESE: 'CANTONESE',
  JAPANESE: 'JAPANESE',
  KOREAN: 'KOREAN',
  VIETNAMESE: 'VIETNAMESE'
};
const TEXT_TO_SPEECH_OPTIONS = exports.TEXT_TO_SPEECH_OPTIONS = {
  OFF: 'OFF',
  MALE: 'MALE',
  FEMALE: 'FEMALE'
};